import { AbortProvider } from './abort.js';

var NAMESPACE = "ABORT";
var ABORTABLE_PROVIDER = "".concat(NAMESPACE, "/PROVIDER");

var abortableApi = function abortableApi(action) {
  return {
    type: ABORTABLE_PROVIDER,
    abort: new AbortProvider(),
    action: action
  };
};

export { ABORTABLE_PROVIDER, abortableApi };
